/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {

      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');
      if (!this.remainingText || !this.fullText) return;

      // Shopify.currency fehlt in manchen Kontexten (Theme-Editor, fruehe
      // Ausfuehrung). Ohne Absicherung wirft der Zugriff, und dann bliebe
      // der CSS-Standard stehen - die Erfolgsmeldung.
      var rate = (window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
      var total = parseInt(this.dataset.cartTotal, 10) || 0;
      var minimum = Math.round((parseInt(this.dataset.minimum, 10) || 0) * rate);
      var percentage = 1;

      if (minimum > 0 && total < minimum) {
        percentage = total / minimum;
        this.remainingText.style.display = 'block';
        this.fullText.style.display = 'none';
      } else {
        this.remainingText.style.display = 'none';
        this.fullText.style.display = 'block';
      }

      this.style.setProperty('--percentage', percentage);

    }
  }
  customElements.define('free-shipping', FreeShipping);
}